import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { GlobalContext } from '../../interfaces/GlobalContext/GlobalContext';
import ProductPrice from '../../interfaces/ProductPrice/ProductPrice';
import { FormFieldName } from '../../interfaces/ProductProperties/ProductProperties';
import Snapshot from '../../interfaces/Snapshot/Snapshot';
import { UrlPaths } from '../../interfaces/UrlPaths/UrlPaths';
import ResultPriceProps from './ResultPrice.props';
import ResultPriceState from './ResultPrice.state';

export default class ResultPrice extends Component<ResultPriceProps, ResultPriceState> {
    static contextType = GlobalContext;
    context!: React.ContextType<typeof GlobalContext>;

    constructor(props: ResultPriceProps) {
        super(props);
        this.state = {
            price: this.calculateResultPrice(),
            paymentPeriodInEachProductIsTheSame: true,
        };
        this.handleBackClick = this.handleBackClick.bind(this);
    }

    updateAndNotify = () => {
        this.setState({
            price: this.calculateResultPrice()
        });
    }

    getSnapshotBeforeUpdate(prevProps: ResultPriceProps): Snapshot {
        return { notifyRequired: prevProps.prices !== this.props.prices };
    }

    componentDidUpdate(prevProps: ResultPriceProps, prevState: ResultPriceState, snapshot: Snapshot) {
        if (snapshot.notifyRequired) {
            this.updateAndNotify();
        }
    }

    calculateResultPrice(): ProductPrice {
        const resultPrice = {
            magicNumber: '',
            paymentPeriod: '',
            price: 0.0,
            priceInclMwst: 0.0,
        };

        let paymentPeriodInEachProductIsTheSame = true;

        Object.keys(this.props.prices).forEach((magicNumber) => {
            const productPrice = this.props.prices[magicNumber];
            resultPrice.price += productPrice.price;
            resultPrice.priceInclMwst += productPrice.priceInclMwst;

            if (resultPrice.paymentPeriod === '') {
                resultPrice.paymentPeriod = productPrice.paymentPeriod;
            } else if (resultPrice.paymentPeriod !== productPrice.paymentPeriod) {
                paymentPeriodInEachProductIsTheSame = false;
            }
        });

        if (resultPrice.price !== 0.0) {
            this.setState({
                paymentPeriodInEachProductIsTheSame: paymentPeriodInEachProductIsTheSame,
            });
        }

        return resultPrice;
    }

    handleBackClick() {
        window.history.back();
    }

    render(): React.ReactNode {
        return (
            <div className="result-price">
                <div className="container result-price__container">
                    {
                        this.state.paymentPeriodInEachProductIsTheSame
                            ? <>
                                <div className="result-price__text-wrapper">
                                    <span className="result-price__price-text">{this.context.i18nProvider.get ? this.context.i18nProvider.get('cartPage.totalPriceComponent.title') : null}</span>
                                    <span className="result-price__price-info">{this.context.i18nProvider.get ? this.context.i18nProvider.get('cartPage.totalPriceComponent.priceInfo') : null}</span>
                                </div>
                                <div className="result-price__price-wrapper">
                                    <span className="result-price__price">{this.state.price.price.toLocaleString('de-DE', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                        useGrouping: true
                                    })}</span>
                                    <span className="result-price__price-label">{
                                        this.context.i18nProvider.get('generalRessources.currency')
                                    } {
                                        Object.keys(this.props.prices).length > 0
                                            ? (this.context.i18nProvider.get('generalRessources.priceSuffix') as string)
                                                .replace(
                                                    '{{paymentperiod}}', 
                                                    this.context.i18nProvider.get(`productPropertiesOverlay.${
                                                        FormFieldName.PAYMENTPERIOD
                                                    }.periods.${
                                                        (this.state.price && this.state.price.paymentPeriod) || '1M'
                                                    }`) || ''
                                                )
                                            : null
                                    }</span>
                                </div>

                                <span className="result-price__price-includes"
                                    dangerouslySetInnerHTML={{
                                        __html: Object.keys(this.props.prices).length > 0
                                            ? (this.context.i18nProvider.get('cartPage.totalPriceComponent.totalPriceTaxReference') as string)
                                                .replace('{{priceinclmwst}}', (this.state.price.priceInclMwst).toLocaleString('de-DE', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                    useGrouping: true
                                                }))
                                                .replace(
                                                    '{{paymentperiod}}', 
                                                    this.context.i18nProvider.get(`productPropertiesOverlay.${
                                                        FormFieldName.PAYMENTPERIOD
                                                    }.periods.${
                                                        (this.state.price && this.state.price.paymentPeriod) || '1M'
                                                    }`) || ''
                                                )
                                            : ''
                                    }}> 
                                </span>
                            </>
                            : undefined
                    }
                    
                    <div className="result-price__back-button-wrapper">
                        <button className="text-icon-link text-icon-link--button text-icon-link--back" 
                            type='button' 
                            onClick={this.handleBackClick}>
                            <span className="text-icon-link__icon"></span>
                            <span className="text-icon-link__text">{this.context.i18nProvider.get ? this.context.i18nProvider.get('cartPage.totalPriceComponent.buttons.back') : null}</span>
                        </button>
                    </div>
                    { this.props.userPermission 
                        ? <Link to={UrlPaths.CUSTOMERDATAPAGE}
                            className='cta-button cta-button--button-red'>{this.context.i18nProvider.get ? this.context.i18nProvider.get('cartPage.totalPriceComponent.buttons.toCounter') : null}</Link>
                        : '' // <p className='result-price__order-message' >{this.context.i18nProvider.get ? this.context.i18nProvider.get('customerDataPage.loginSection.permissionMessage') : ''}</p>
                    }
                </div>
            </div>
        );
    }
}
